import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const badgeVariants = cva("inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-medium whitespace-nowrap", {
  variants: {
    variant: {
      default: "border-transparent bg-[var(--color-info-bg)] text-[var(--color-info-fg)]",
      outline: "text-[var(--color-foreground)]",
      success: "border-transparent bg-[var(--color-success-bg)] text-[var(--color-success-fg)]",
      warning: "border-transparent bg-[var(--color-warning-bg)] text-[var(--color-warning-fg)]",
      destructive: "border-transparent bg-[var(--color-danger-bg)] text-[var(--color-danger-fg)]",
      muted: "border-transparent bg-[var(--color-muted)] text-[var(--color-muted-foreground)]",
    },
  },
  defaultVariants: { variant: "default" },
});

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement>, VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}
